import {LOWEST_C_KEY, OCTAVE_IN_SEMITONE} from "../global/types/MusicalConstants";

export default class Ambitus {
  low: number = -1; // -1 if undefined
  high: number = -1; // -1 if undefined
}
export function isAmbitusContained(child: Ambitus, parent: Ambitus) {
  return parent.high >= child.high && parent.low <= child.low
}

/**
 * Flatten ambitus used to compare multiple ambitus without considering base Octave
 * @param ambitus
 */
export function flattenAmbitus(ambitus: Ambitus): Ambitus {
  let low = (ambitus.low % OCTAVE_IN_SEMITONE);
  if (low < LOWEST_C_KEY) {
    low += OCTAVE_IN_SEMITONE;
  }
  return {
    low: low,
    high: low + (ambitus.high - ambitus.low)
  }
}
export function flattenAmbitusAndCenterInIdealAmbitus(ambitus: Ambitus, idealAmbitus: Ambitus): Ambitus {
  const flattenedAmbitus = flattenAmbitus(ambitus);
  let leftShiftedCount: number = 0

  while (flattenedAmbitus.high + (OCTAVE_IN_SEMITONE * (leftShiftedCount * 2 + 1)) < idealAmbitus.high) {
    leftShiftedCount++;
  }

  flattenedAmbitus.low += leftShiftedCount * OCTAVE_IN_SEMITONE;
  flattenedAmbitus.high += leftShiftedCount * OCTAVE_IN_SEMITONE;

  if (idealAmbitus.high - flattenedAmbitus.high < flattenedAmbitus.low - idealAmbitus.low) {
    if (flattenedAmbitus.low - OCTAVE_IN_SEMITONE >= idealAmbitus.low) {
      flattenedAmbitus.low -= OCTAVE_IN_SEMITONE;
      flattenedAmbitus.high -= OCTAVE_IN_SEMITONE;
    }
  }

  return flattenedAmbitus
}

export function getAmbitusMarginInSemiTone(ambitus: Ambitus, parent: Ambitus): number {
  const flattenedParent = flattenAmbitus(parent);
  const flattenedAmbitus = flattenAmbitusAndCenterInIdealAmbitus(ambitus, flattenedParent);
  if (!isAmbitusContained(flattenedAmbitus, flattenedParent)) {
    return -1;
  }

  let ambitusMargin = 999;
  if (flattenedAmbitus.low >= flattenedParent.low) {
    ambitusMargin = Math.min(ambitusMargin, flattenedAmbitus.low - flattenedParent.low);
  }
  if (flattenedAmbitus.high <= flattenedParent.high) {
    ambitusMargin = Math.min(ambitusMargin, flattenedParent.high - flattenedAmbitus.high);
  }

  return ambitusMargin;
}
